import React from 'react'
import { Grid, Row, Col } from 'react-bootstrap'
import { Helmet } from 'react-helmet'
import Footer from './Footer'
import Audiovizualny from './logos/audiovizualny'
import Sng from './logos/sng'
import Embassy from './logos/embassy'
import Zse from './logos/nadacia-zse'
import O2 from './logos/o2'
import Rtv from './logos/rtv'
import Tuli from './logos/tuli'
import Eset from './logos/eset'
import Literarny from './logos/literarny'
import Kvant from './logos/kvant'
import My from './logos/my'
import StartLab from './logos/startlab'
import SFU from './logos/sfu'
import './partneri.css'

const content2 = 'Bratislavská projekcia filmu je realizovaná pod záštitou primátora Hlavného mesta SR Bratislavy pána Iva Nesrovnala.'

const Partneri = () => (
  <Grid className="partneri-page static-page">
    <Helmet>
      <title>Partneri - SPÝTAJ SA VAŠICH 68</title>
    </Helmet>
    <Row>
      <Col xs={12}>
        <h1>Partneri</h1>
      </Col>
    </Row>
    <Row>
      <Col className="content" md={4}>
        <div className="card">
          <p>Nad projektom prevzal záštitu prezident Slovenskej republiky pán Andrej Kiska.</p>
          <p>{content2}</p>
        </div>
        <Footer />
      </Col>
      <Col md={8}>
        <p>Realizáciu tohto filmu finančne podporili:</p>
        <ul className="partner-logos">
          <li className="audioviz">
            <a href="//www.avf.sk/" target="_blank" rel="noopener noreferrer">
              <Audiovizualny />
            </a>
          </li>
          <li className="embassy"><Embassy /></li>
          <li className="eset"><Eset /></li>
          <li className="o2"><O2 /></li>
          <li className="zse"><Zse /></li>
          <li className="literarny"><Literarny /></li>
        </ul>

        <p>Koproducent filmu:</p>
        <ul className="partner-logos">
          <li className="rtv"><Rtv /></li>
        </ul>

        <p>Partneri projektu:</p>
        <ul className="partner-logos">
          <li className="kvant"><Kvant /></li>
          <li className="sng"><Sng /></li>
          <li className="tuli"><Tuli /></li>
          <li className="my"><My /></li>
          <li className="startlab"><StartLab /></li>
          <li className="upn"><img src="../images/upn.png" alt="" /></li>
          <li className="startlab"><SFU /></li>
        </ul>
      </Col>
    </Row>
  </Grid>
)

export default Partneri



// WEBPACK FOOTER //
// ./src/components/Static/Partneri.js